import React from "react"
import { Box, Flex, Text } from "@chakra-ui/react"

type Props = {
  whatsInside: WhatsInsideProps[]
}

const ProductTabBundle: React.FC<Props> = ({ whatsInside }) => {
  return (
    <Flex gap={{ base: "16px", lg: "40px" }} flexDir={{ base: "column", lg: "row" }}>
      <Box p={{ base: "16px", lg: "32px" }} w={{ base: "100%", lg: "50%" }}>
        {whatsInside.map(({ id, title, variant, description }) => (
          <Box key={id} marginBottom={5}>
            <Text textDecoration="underline" fontWeight={700} lineHeight="1.5" dangerouslySetInnerHTML={{ __html: title }} />
            <Text lineHeight="1.5" dangerouslySetInnerHTML={{ __html: variant }} />
            <Box lineHeight="1.5" dangerouslySetInnerHTML={{ __html: description }} />
          </Box>
        ))}
      </Box>
    </Flex>
  )
}

export default React.memo(ProductTabBundle)

export type WhatsInsideProps = {
  title: string
  variant: string
  description: string
}
